import type { BaseUser } from '@helpers/auth/types';

import { getInitialsFromName } from './getInitialsFromName';

export const getInitials = (user: BaseUser) =>
  getInitialsFromName([user?.firstName, user?.lastName].filter(Boolean).join(' '));
